"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckStableIdentity = void 0;
var react_1 = __importDefault(require("react"));
function useCheckStableIdentity(params) {
    var prev = react_1.default.useRef({});
    Object.keys(params).forEach(function (key) {
        if (params[key] !== prev.current[key]) {
            console.log("%cChange", "color:red", "in", key);
            console.log("Prev", prev.current[key]);
            console.log("New", params[key]);
        }
        else
            console.log("Same", key);
    });
    Object.assign(prev.current, params);
}
exports.useCheckStableIdentity = useCheckStableIdentity;
//# sourceMappingURL=useCheckStableIdentity.js.map